<template>
	<div>
		<!-- <NotificationIframe></NotificationIframe> -->
		<div class="container-fluid right_wrapper">
				<!-- <div style = "padding-top:10px"> -->
					<!-- <button class="close"><i class="fa fa-times" aria-hidden="true" style = "color:black" @click = "goBack()"></i></button> -->
				<!-- </div> -->
				<ReleaseNotesHeader @getList = "getList"/>
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
				<div v-else>
					<div v-if = "(list && list.length) || notesList.length">
						<ReleaseNotesListGrid @getList = "getList" class="table_wrap no_footer"/>
					</div>
					<div v-else>
						<NoDataAvailable displayMessage="No Data Is Available" ></NoDataAvailable>
					</div>

				</div>
			</div>
	</div>
</template>

<script>

import ReleaseNotesHeader from "./ReleaseNotesHeader.vue"
import ReleaseNotesListGrid from "./ReleaseNotesListGrid.vue"
import NoDataAvailable from '@/components/NoDataAvailable.vue'

export default {
	name: "ReleaseNotes",
	components:{ReleaseNotesHeader, ReleaseNotesListGrid, NoDataAvailable},
	data(){
		return{
			showLoader:false,
			list:[]
		}
	},
	computed:{
		notesList:{
			set(val) {
				this.$store.commit("release/setNotesList", val);
			},
			get() {
				return this.$store.state.release.notesList;
			}
		}
	},
	mounted(){
		
		this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'resourceAndUpdateList'})

		if(this.$store.state.calledFromCancel){
			this.$store.state.calledFromCancel = false
		}
		else{
			this.getList()
		}
	},
	methods:{
		goBack(){
			let path = this.$store.state.release.pathBeforeReleaseNote;

			if(path){
				this.$router.push({path:path});
				this.$store.state.release.pathBeforeReleaseNote = ''
			}
			else{
				this.$router.push({path:'/campaignList'})
			}

			//this.$router.back()
		},
		getList(data){
			let vm = this;
			this.showLoader = true;
			let payload = {}
			if(data){
				payload = {
					type:data
				}
			}


			this.$store.dispatch('release/getList', payload).then((res) => {
				vm.list = res
				vm.showLoader = false;
			})
		}
	}
}
</script>
